import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styles from './navigationlist.module.scss';
import { linkResolver } from '../helper';
import NavigationItem from '../NavigationItem';

class NavigationListContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toggled: props.toggled,
    };
    this.items = [];
  }

  componentWillMount() {
    if (this.props.items) {
      this.items = this.props.items.map(x => Object.assign({}, x, { url: linkResolver(x.page.type, x.page.uid)}));
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      toggled: nextProps.toggled,
    });
  }

  render() {
    if (!this.props.items) return null;
    const cssClass = [styles.list];
    const itemCssClass = [styles.item];
    if (this.state.toggled) {
      itemCssClass.push(styles.in);
      cssClass.push(styles.show);
    }
    return (
      <nav className={cssClass.join(' ')}>
        {this.items.map((x, i) => <NavigationItem key={`item_${i}`} className={itemCssClass.join(' ')} style={{'transitionDelay': `${i * 50}ms`}} {...x} /> )}
      </nav>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    toggled: state.navigation.navToggled,
  }
};

const mapDispatchToProps = (dispatch) => {
  return { }
}

const NavigationList = connect(
  mapStateToProps,
  mapDispatchToProps,
)(NavigationListContainer);

NavigationList.defaultProps = {

};

NavigationList.propTypes = {

};

export default NavigationList;



// WEBPACK FOOTER //
// ./src/components/NavigationList/index.jsx